import React from 'react'
import { Helmet } from 'react-helmet'

const Head = () => {
  return (
    <Helmet>
      <title>The Twitterverse</title>
      <meta
        name="description"
        content="Join Spacecadet in celebrating 15 years of the little blue bird by exploring the best tweets of all-time, from the all-stars of the platform."
      />
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover" />

      <link rel="icon" href="https://twitterverse.space/favicon.ico" />
      <link rel="icon" type="image/png" sizes="32x32" href="https://twitterverse.space/favicons/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="https://twitterverse.space/favicons/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="https://twitterverse.space/favicons/favicon-16x16.png" />

      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://twitterverse.space" />
      <meta property="og:title" content="The Twitterverse" />
      <meta
        property="og:description"
        content="Join Spacecadet in celebrating 15 years of the little blue bird by exploring the best tweets of all-time, from the all-stars of the platform."
      />
      <meta property="og:image" content="https://twitterverse.space/assets/meta.png" />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://twitterverse.space" />
      <meta property="twitter:title" content="The Twitterverse" />
      <meta
        property="twitter:description"
        content="Join Spacecadet in celebrating 15 years of the little blue bird by exploring the best tweets of all-time, from the all-stars of the platform."
      />
      <meta property="twitter:image" content="https://twitterverse.space/assets/meta.png" />
    </Helmet>
  )
}

export default Head
